import { createGlobalStyle } from 'styled-components';

const FontFamily = createGlobalStyle`
  .planne-widget-direct-link * {
    font-family: Lato, sans-serif;
  }

  .planne-widget-modal * {
    font-family: Lato, sans-serif;
  }

  .planne-widget-drawer * {
    font-family: Lato, sans-serif;
  }
`;

export default FontFamily;
